import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitContestantInterest = (data) =>
  api.post("/forms/contestant-interest", data);
export const submitSponsorInquiry = (data) =>
  api.post("/forms/sponsor-inquiry", data);
export const submitAttendeeInterest = (data) =>
  api.post("/forms/attendee-interest", data);
export const submitContact = (data) => api.post("/forms/contact", data);
